/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBarToLeft = createReactComponent("arrow-bar-to-left", "IconArrowBarToLeft", [
  ["path", { d: "M10 12l10 0", key: "svg-0" }],
  ["path", { d: "M10 12l4 4", key: "svg-1" }],
  ["path", { d: "M10 12l4 -4", key: "svg-2" }],
  ["path", { d: "M4 4l0 16", key: "svg-3" }]
]);

export { IconArrowBarToLeft as default };
//# sourceMappingURL=IconArrowBarToLeft.js.map
